/* eslint-disable unicorn/filename-case */
import { buildS3ObjectUrl, DEFAULT_S3_REGION } from "@repo/utils";

/**
 * Handles downloading a buffer as a PDF file
 */
export function handleDownloadBuffer(
  buffer: ArrayBuffer,
  filename: string,
  mimeType = "application/pdf"
) {
  // Create a blob from the array buffer
  const blob = new Blob([buffer], { type: mimeType });

  // Create download link
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;

  // Trigger download
  document.body.appendChild(link);
  link.click();

  // Clean up
  setTimeout(() => {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, 100);
}

export function downloadFile(url: string, filename: string) {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
}

export function findKeyValue<T = unknown>(obj: unknown, searchKey: string): T | undefined {
  // Convert search key to lowercase for case-insensitive comparison
  const keyToFind = searchKey.toLowerCase();

  // Helper function to recursively search through object
  function search(current: unknown): T | undefined {
    // Return null if input is not an object
    if (current === null || current === undefined || typeof current !== "object") {
      return undefined;
    }

    // Check each key in current object
    for (const key in current) {
      // Case-insensitive key comparison
      if (typeof key === "string" && key.toLowerCase() === keyToFind) {
        return (current as Record<string, unknown>)[key] as T;
      }

      // If value is an object or array, search recursively
      const value = (current as Record<string, unknown>)[key];
      if (value !== null && value !== undefined && typeof value === "object") {
        const result = search(value);
        if (result !== undefined) {
          return result;
        }
      }
    }

    return undefined;
  }

  return search(obj);
}

export function getS3Url(key: string, bucket?: string) {
  const envBucket = import.meta.env.VITE_S3_BUCKET as string | undefined;
  const bucketName = bucket ?? envBucket;
  if (bucketName == null || bucketName === "") return undefined;

  return buildS3ObjectUrl({
    bucket: bucketName,
    key,
    region: (import.meta.env.VITE_AWS_REGION as string | undefined) || DEFAULT_S3_REGION,
  });
}
